import { ConfirmationStayTable } from "./ConfirmationStayTable";
import { ConfirmationTrainTable } from "./ConfirmationTrainTable";
import { ConfirmationAirTable } from "./ConfirmationAirTable";
import { ConfirmationShipTable } from "./ConfirmationShipTable";
import { ConfirmationBusTable } from "./ConfirmationBusTable";
import { ConfirmationTicketTable } from "./ConfirmationTicketTable";
import { ConfirmationMealTable } from "./ConfirmationMealTable";
import { ConfirmationCrewTable } from "./ConfirmationCrewTable";
import { ConfirmationMiscTable } from "./ConfirmationMiscTable";
import { ConfirmationGeneralTable } from "./ConfirmationGeneralTable";

/** 八类专表及通用表的稳定组件映射，分类切换不接管主行池状态。 */
export const confirmationTables = {
  stay: ConfirmationStayTable,
  train: ConfirmationTrainTable,
  air: ConfirmationAirTable,
  ship: ConfirmationShipTable,
  bus: ConfirmationBusTable,
  ticket: ConfirmationTicketTable,
  meal: ConfirmationMealTable,
  crew: ConfirmationCrewTable,
  misc: ConfirmationMiscTable,
  all: ConfirmationGeneralTable,
};
